import axios from "axios";
import { api, key } from "./api";

const apiUrl = process.env.REACT_APP_API_URL;
const endpoint = apiUrl + "/volontariat/Ami";

export const AMIService = {
  async insert(data) {
    try {
      const result = await axios.post(endpoint + "/insertposte", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(input) {
    try {
      const result = await api.put(endpoint + "/update", input);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { id_type: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async list(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: { ...filtre, k: key } },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(id) {
    try {
      const result = await api.post(endpoint + "/delete", id);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getExperiencesList(filtre) {
    try {
      const result = await api.get(
        endpoint + "/recuperer_experience_association",
        { params: filtre },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async downloadAllPj(filtre) {
    try {
      const result = await api.get(endpoint + "/telecharger_tout_zip", {
        params: filtre,
        responseType: "blob",
      });

      if (result) {
        return result;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getExperiencesAndReponsesList(filtre) {
    try {
      const result = await api.get(
        endpoint + "/recuperer_experience_et_reponse",
        { params: filtre },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async create(data) {
    throw new Error("Method not implemented.");
  },
  async softDelete(data) {
    throw new Error("Method not implemented.");
  },
  async hardDelete(data) {
    throw new Error("Method not implemented.");
  },
  async restore(data) {
    throw new Error("Method not implemented.");
  },
};
